import { PROCESS } from "../../data/content";
import { Reveal, Overline } from "./Reveal";
import { scrollToId } from "../../hooks/useSmoothScroll";
import { ArrowRight } from "lucide-react";

export default function Process() {
  return (
    <section id="munkafolyamat" data-testid="process-section" className="scroll-mt-24 bg-white py-16 sm:py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal><Overline>Munkafolyamat</Overline></Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0E5A75] text-balance">
                  Hogyan indul el egy együttműködés?
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-6 text-base text-slate-600 leading-relaxed">
                  Az első kapcsolatfelvételtől a kivitelezésig végigkísérjük Önt. Az egyes lépések a
                  tető állapotától és az igényektől függően alakulnak.
                </p>
              </Reveal>
              <Reveal delay={0.15}>
                <button
                  data-testid="process-cta"
                  onClick={() => scrollToId("ajanlatkeres")}
                  className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#0E5A75] px-6 py-3.5 text-sm font-semibold text-white hover:bg-[#0E5A75] hover:scale-[1.03] transition-transform"
                >
                  Kezdjük el <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative">
              {PROCESS.map((step, i) => (
                <Reveal key={step.title} delay={i * 0.06}>
                  <li data-testid={`process-step-${i}`} className="group flex gap-6 sm:gap-8 border-b border-slate-200 py-8 first:pt-0 last:border-b-0">
                    <span className="shrink-0 text-5xl sm:text-6xl font-extrabold leading-none tabular-nums text-slate-200 group-hover:text-emerald-400 transition-colors">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="pt-1">
                      <h3 className="text-xl sm:text-2xl font-bold text-[#0E5A75]">{step.title}</h3>
                      <p className="mt-2 text-base text-slate-600 leading-relaxed max-w-xl">{step.desc}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
